import { Controller } from "@hotwired/stimulus"

// Add/remove instrument+quantity rows from a <template>. The fields use paired parallel arrays
// (instrument_names[] / instrument_quantities[]) that the server zips into brief.instrumentation.
export default class extends Controller {
  static targets = ["rows", "template"]

  // Start with one (unselected) row so the field is discoverable; the server drops blank-name rows.
  connect() {
    if (this.rowsTarget.children.length === 0) this.add()
  }

  add() {
    this.rowsTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML)
  }

  remove(event) {
    event.target.closest("[data-instrument-row]")?.remove()
  }
}
